import { type App, reactive, readonly } from 'vue';

// Import the global options.
import { preconToastsOptionsInjectionKey } from './symbols';
import {
    type PreconToastsGlobalOptions,
    normalizePreconToastsOptions,
    type actionMessageOptions,
    type errorMessageOptions,
} from './options';

// Export the
export type {
    PreconToastsGlobalOptions,
    actionMessageOptions,
    errorMessageOptions,
};

// Export the helpers that you want to use outside of this library.

// Export the composables that you want to use outside of this library.
export * from './composables/usePreconToasts';

export { useUnauthorizedToast } from './composables/useUnauthorizedToast';

// The definition of the plugin that installs the
export default {
    install(app: App, options?: PreconToastsGlobalOptions) {
        /// NORMALIZE THE OPTIONS
        const normalizedOptions = reactive(
            normalizePreconToastsOptions(options ?? {})
        );

        /// INJECT THE OPTIONS
        // This ensures that the options are available to the components in this library.
        app.provide(
            preconToastsOptionsInjectionKey,
            readonly(normalizedOptions)
        );
    },
};
